import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/EmbedView.vue";

const routes = [
  {
    path: "/",
    name: "embed",
    component: HomeView,
  },

  {
    path: "/demo",
    name: "widget-demo",
    component: () => import("../views/WidgetDemoView.vue"),
  },

  {
    path: "/test",
    name: "biometric-test",
    component: () => import("../components/BiometricTestPage.vue"),
  },

  {
    path: "/flutter-guide",
    name: "flutter-integration-demo",
    component: () => import("../views/FlutterIntegrationDemo.vue"),
  },

  {
    path: "/embed",
    name: "embed-view",
    component: () => import("../views/EmbedView.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

export default router;
